// https://medium.com/@kyleducharme/developing-custom-dropdowns-with-vanilla-js-css-in-under-5-minutes-e94a953cee75

main.dropdown = (function () {
	var filters = document.getElementsByClassName("c-dropdown");
    var init = function () {
    	if (filters.lenght < 1) { return; }
    	for (var i = 0; i < filters.length; i++) {
    		var filter = filters[i];
    		_dropdown(filter);
    	}
    };
    
  	var _dropdown = function (filter) {
  		var component = document.createElement("div");
		var input = _createInput(filter);
		var dropdown = _showDropdown(filter);

		component.appendChild(input);
		component.appendChild(dropdown);
		filter.appendChild(component);
	};

	var _createInput = function (filter) {
		// Creates the input outline
		var input = document.createElement("div");
		input.classList = "input";
		input.addEventListener("click", function () {
			var parent = input.parentNode;
			_toggleDropdown(parent);
		}.bind(input));

		// Creates the input placeholder content
		var inputPlaceholder = document.createElement("div");
		inputPlaceholder.classList = "input__placeholder";
		var placeholder = document.createElement("p");
		if (true) {}
		placeholder.textContent = filter.dataset.placeholder;
		placeholder.classList.add('placeholder');
		placeholder.dataset.slug = filter.dataset.placeholderSlug;
		if (placeholder.dataset.slug != '') {
			placeholder.classList.add('input__selected');
		}

		// Appends the placeholder and chevron (stored in assets.js)
		inputPlaceholder.appendChild(placeholder);
		input.appendChild(inputPlaceholder);

		return input;
	};

	function _getParameter(query, paramName) {
	  var searchString = query.substring(1),
	      i, val, params = searchString.split("&");

	  for (i=0;i<params.length;i++) {
	    val = params[i].split("=");
	    if (val[0] == paramName) {
	      return val[1];
	    }
	  }
	  return null;
	}

	var _handleSelects = function (structure, title, slug, query, index) {
			var option = document.createElement("div");
			option.addEventListener("click", function () { 
				var parent = structure.parentNode.parentNode;
				_selectOption(title, slug, query, parent);
			}.bind(option, structure), true);
			option.setAttribute("id", index);
			var t = document.createElement("p");
			t.textContent = title;
			t.dataset.slug = slug;
			var queryParam = _getParameter(window.location.search, query);
			if (queryParam && queryParam === slug) {
				option.classList.add('is-active');
				option.appendChild(t);
			} else if ((queryParam == null || queryParam == '') && slug == '') {
				return;
			} else if (slug == '') {
				option.classList.add('is-reset');
				option.appendChild(t);
			} else {
				option.appendChild(t);
			}
			structure.appendChild(option);
	};

	var _showDropdown = function (filter) {
		var structure = document.createElement("div");
		structure.classList.add("structure", "u-hidden");
		var options = JSON.parse(filter.dataset.options);
		for (var i = 0; i < options.length; i++) {
			var option = options[i];
			var title = option.title;
			var slug = option.slug;
			var query = option.query;
			_handleSelects(structure, title, slug, query, i);
		}
		return structure;
	};

	var _toggleDropdown = function (parent) {
		var dropdown = parent.querySelector(".structure");
		if (dropdown) {
			dropdown.classList.toggle("u-hidden");
		}
		var input = parent.querySelector(".input");
		if (input) {
			input.classList.toggle("input__active");	
		}
		var container = parent.parentNode;
		if (container) {
			container.classList.toggle("is-open");
		}
	};

	var buildQuery = function (data) {
		// If the data is already a string, return it as-is
		if (typeof (data) === 'string') return data;
		// Create a query array to hold the key/value pairs
		var query = [];
		// Loop through the data object
		for (var key in data) {
			if (data.hasOwnProperty(key)) {
				// Encode each key and value, concatenate them into a string, and push them to the array
				query.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
			}
		}
		// Join each item in the array with a `&` and return the resulting string
		return query.join('&');
	};

	var _selectOption = function (title, slug, query, parent) {
		var text = parent.querySelector('.placeholder');
		text.textContent = title;
		text.dataset.slug = slug;
		text.classList.add('input__selected');
		_toggleDropdown(parent);

		var endpoint = window.location.href.split('?')[0];
		var queryString, filterElement, filterPlaceholder;
		if (query == 'client') {
			filterElement = document.querySelector('.c-dropdown--categories');
			filterPlaceholder = filterElement.querySelector('.placeholder');
			var category = filterPlaceholder.dataset.slug;
			queryString = buildQuery({
				client: slug,
				category: category
			});
		} else if (query == 'category') {
			filterElement = document.querySelector('.c-dropdown--clients');
			filterPlaceholder = filterElement.querySelector('.placeholder');
			var client = filterPlaceholder.dataset.slug;
			queryString = buildQuery({
				client: client,
				category: slug
			});
		}
		var callURL = endpoint + '?' + queryString;
		// history.pushState(null, null, callURL);
		var grid = document.querySelector('.c-grid');
        grid.classList.add('u-hidden-transition');
		setTimeout(function() {
			window.location = callURL;
        }.bind(callURL), 100);
	};

    return {
        init: init
    };

})();
